/**
 * The machine-readable half of a refusal.
 *
 * The API answers a rule it will not break with `{ message, reason }` — the sentence for a person, the
 * code for us. The thrown error's own `message` is that sentence, so branching on it never matches a
 * code; `reason` is what a screen should test to decide whether it has something better to say than the
 * global error toast.
 */
export const reasonOf = (error: unknown): string => (error as { reason?: string } | null)?.reason ?? '';
